export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8650.11037380.jpg";